import { createMachine } from "xstate";
import { changePortoutStatus } from "@nju/data-access-portal-service";
import { isError } from "@nju/result";

type IEvent =
  | { type: "SUCCESS" }
  | { type: "ERROR" }
  | { type: "EXPIRED" }
  | { type: "CANCEL_PORTOUT" };

interface IContext {
  userId: string | undefined;
  taskId: string | undefined;
}

export const cancelPortoutMachine = createMachine(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    context: {
      userId: "",
      taskId: "",
    },
    initial: "ready",
    states: {
      ready: {
        on: {
          CANCEL_PORTOUT: {
            target: "cancelPortout",
          },
        },
      },
      cancelPortout: {
        invoke: {
          src: "cancelPortout",
        },
        on: {
          SUCCESS: {
            target: "success",
          },
          ERROR: {
            target: "error",
          },
          EXPIRED: {
            target: "expired",
          },
        },
      },
      success: {
        type: "final",
      },
      error: {
        type: "final",
      },
      expired: {
        type: "final",
      },
    },
  },
  {
    services: {
      cancelPortout: ({ userId, taskId }) => {
        return async (callback) => {
          if (!userId || !taskId) {
            throw new Error("Missing userId or taskId");
          }
          const result = await changePortoutStatus({ userId, taskId });

          if (isError(result)) {
            if (result.err.code === "EXPIRED") {
              return callback("EXPIRED");
            }

            return callback("ERROR");
          }

          return callback("SUCCESS");
        };
      },
    },
  },
);
